import axios from 'axios';
import { API_ENDPOINTS } from '../assets/api/endpoints';

const SOCKET_TOKEN_TIMEOUT_MS = 15000;

function extractSocketToken(data: unknown): string {
	if (data == null || typeof data !== 'object') {
		throw new Error('Invalid socket token response');
	}
	const token = (data as { token?: unknown }).token;
	if (typeof token === 'string' && token.length > 0) {
		return token;
	}
	throw new Error('Invalid socket token response');
}

/**
 * Returns a short-lived JWT for STOMP CONNECT only. The session itself lives in HttpOnly cookies, so the
 * browser authenticates this request; a new token is fetched before every connect attempt, which means a
 * reconnect after a long suspend (mobile background tab, bfcache) never uses an expired one.
 */
export async function fetchSocketJwtToken(): Promise<string> {
	const { data } = await axios.post(API_ENDPOINTS.socketToken, undefined, { timeout: SOCKET_TOKEN_TIMEOUT_MS });
	return extractSocketToken(data);
}
